export enum SortDirection {
    DESC = 'Desc',
    ASC = 'Asc'
}
